export default __webpack_public_path__ + "static/media/vk.be0c45c8.svg";